// api.js
export async function fetchGeneratedResponse(input, useFetchChatEndpoint, context) {
  console.log('process.env.REACT_APP_API_URL', process.env.REACT_APP_API_URL);

  try {
    let response;
    let data;

    if (!useFetchChatEndpoint) {
      response = await fetch(
          `${process.env.REACT_APP_API_URL}/fetch-url?url=${encodeURIComponent(input)}`
      );
      data = await response.json();
    } else {
      response = await fetch(
          `${process.env.REACT_APP_API_URL}/fetch-chat`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              question: input,
              context: context
            })
          }
      );
      data = await response.json();
    }

    if (data.error) {
      throw new Error(data.error);
    }

    return { response: data.response, newContext: useFetchChatEndpoint ? context : data.response };
  } catch (error) {
    console.error(`Failed to fetch the data`, error);
    return { response: null, newContext: context };
  }
}
